import React, { useEffect, useState } from 'react';
import "../../styles/profileStyles/myProfileMain.css";
import BeatLoader from "react-spinners/BeatLoader"
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer
} from "recharts";
import { useParams } from 'react-router-dom';

export default function MyProfileMain({ addToast }) {
    const [cardDatas, setCardDatas] = useState(null);
    const [isFollowing, setIsFollowing] = useState(true);
    const [myUsername, setMyUsername] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [isOwnProfile, setIsOwnProfile] = useState(false);
    const { username: targetUsername } = useParams();


    // const cardDatas = {
    //     success: true,
    //     profileDatas: {
    //         username: "NagyonHosszuFelhasznalonevTeszt123",
    //         followers_count: 128,
    //         following_count: 54
    //     },
    //     chartData: [
    //         { date: "Week 01", rate: 45 },
    //         { date: "Week 02", rate: 60 },
    //         { date: "Week 03", rate: 52 },
    //         { date: "Week 04", rate: 70 },
    //         { date: "Week 05", rate: 30 },
    //         { date: "Week 06", rate: 80 }
    //     ],
    //     strategyChartData: [
    //         { date: "Week 01", profit: 0 },
    //         { date: "Week 02", profit: 1200 },
    //         { date: "Week 03", profit: -800 },
    //         { date: "Week 04", profit: 2000 },
    //         { date: "Week 05", profit: 35612 },
    //         { date: "Week 06", profit: -15000 }
    //     ],
    //     leagueStats: [
    //         {
    //             league: "Premier League Anglia Nagyon Hosszú Név",
    //             rate: 65,
    //             total: 34
    //         },
    //         {
    //             league: "La Liga",
    //             rate: 55,
    //             total: 20
    //         },
    //         {
    //             league: "Serie A Olaszország",
    //             rate: 28,
    //             total: 18
    //         },
    //         {
    //             league: "Bundesliga",
    //             rate: 48,
    //             total: 25
    //         },
    //         {
    //             league: "Ligue 1 Franciaország Extra Hosszú",
    //             rate: 75,
    //             total: 40
    //         }
    //     ]
    // };


    // ADATOK LEKÉRÉSE
    
    useEffect(() => {
        fetch(`https://focifanatik.hu/api/profile_API/profileMain.php?username=${targetUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setCardDatas(data);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);



    // MEGNÉZZÜK KI A BEJELENTKEZETT FELHASZNÁLÓ
    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (!data.loggedIn) {
                    // window.location.href = "/regisztracio";
                    setIsLoggedIn(false);
                }
                else if (data.loggedIn) {
                    setIsLoggedIn(true);
                    setMyUsername(data.username);
                }
            });
    }, []);

    // MEGNÉZZÜK HOGY KÖVETI-E MÁR A FELHASZNÁLÓT
    useEffect(() => {
        fetch(`https://focifanatik.hu/api/profile_API/components/followChecker.php?username=${targetUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setIsFollowing(data.isFollowing)
                    setIsOwnProfile(data.isOwnProfile);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);


    // KÖVETÉS/KIKÖVETÉS
    const handleFollow = () => {
        fetch(`https://focifanatik.hu/api/profile_API/components/follow.php?username=${targetUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setIsFollowing(data.following)
                }
                else {
                    addToast("Hiba történt a követésnél!", "warning");
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));

    };


    if (!cardDatas) {
        return (
            <>
                <div className='loading-bg-profileBar'><BeatLoader color="white" size={55} /></div>
                <div className='loading-bg-content'></div>
            </>
        );
    }
    return (
        <>

            <div className='myProfilePage-topProfileBar'>


                <div className='myProfilePic'>
                    <img src="https://focifanatik.hu/favicon.ico" alt="" />
                </div>

                <h2 className='myProfileInfo-name'>{cardDatas.profileDatas.username}</h2>

                <div className='myProfileFollowStats'>
                    <div className='followStatItem'>
                        <span className='followLabel'>Követések</span>
                        <span className='followCount'>{cardDatas.profileDatas.following_count}</span>
                    </div>
                    <div className='followStatItem'>
                        <span className='followLabel'>Követők</span>
                        <span className='followCount'>{cardDatas.profileDatas.followers_count}</span>
                    </div>
                </div>

                {isLoggedIn && !isOwnProfile && (
                    <button className='followBtn' onClick={handleFollow}>
                        {isFollowing ? "Kikövetés" : "Követés"}
                    </button>
                )}


            </div>

            {/* TARTALOM */}
            <div className='myProfilePage-content'>
                <div className='myProfileMainStatsGrid'>

                    <div className='myProfileMainCardOne'>
                        <h3>Tippjáték találati arány</h3>

                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={cardDatas.chartData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="rate"
                                    stroke="oklch(68% 0.24475 141.51)"
                                    strokeWidth={3}
                                />
                            </LineChart>
                        </ResponsiveContainer>

                    </div>

                    <div className='myProfileMainCardTwo'>
                        <h3>Stratégia összegző</h3>

                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={cardDatas.strategyChartData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="profit"
                                    stroke="oklch(68% 0.24475 141.51)"
                                    strokeWidth={3}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>

                    <div className='myProfileMainCardThree'>
                        <div className='myProfileMainCardThree-title'>
                            <h3>Tippjáték találati arány ligák szerint</h3>
                        </div>

                        <div className='myProfileTippsStatBoxWrapper'>

                            {cardDatas.leagueStats.map((stat, index) => (
                                <div className='myProfileTippsStatBox' key={index}>

                                    <div className='myProfileTippsStatBoxDetails'>
                                        {/* MAJD LE KELL ITT LIMITÁLNI HOGY MAX 21 betű lehessen */}
                                        <h4>{stat.league.slice(0, 15)}</h4>
                                        {/* ITT MAJD MEG KELL CSINALNI HOGYHA 50 SZÁZALÉK FELETT VAN AKKOR myProfileTippsStatBoxDetailsGreen ha 30 alatt akkor myProfileTippsStatBoxDetailsRed legyen a class */}
                                        <p className={`${stat.rate > 50 ? "myProfileMainStatBoxDetailsGreen" : stat.rate < 30 ? "myProfileMainStatBoxDetailsRed" : "myProfileMainStatBoxDetailsYellow"}`}>
                                            {stat.rate}% / {stat.total} tipp
                                        </p>
                                    </div>

                                </div>
                            ))}


                        </div>

                    </div>

                </div>
            </div>
        </>
    );
}